type IWorkflowKey = "Login" | "Logout" | "Vehicle change" | "Attach trailer" | "Detach trailer";

interface IAuditDeviceParams {
    assetType: string;
    assetName: string;
    assetId: string;
}

export const enum AuditType {
    HosVerify = "SkipHosVerify",
    HosClaimUnassigned = "SkipHosClaimUnassigned",
    DvirInspect = "SkipDvirInspect"
}

const AUDIT_STRINGS = {
    SkipHosVerify: "At least one HOS log was left uncertified.",
    SkipHosClaimUnassigned: "Unassigned HOS logs were not claimed.",
    SkipDvirInspect: "A new inspection was not completed for {assetType}: {assetName} (ID: {assetId})."
};

const WORKFLOW_STRING = "{0}: ";

function getAuditMessage(auditType: AuditType, workflow: IWorkflowKey, optionalDeviceParams?: IAuditDeviceParams) {
    let baseMessage: string = WORKFLOW_STRING.replace("{0}", workflow) + AUDIT_STRINGS[auditType];

    if (auditType === AuditType.DvirInspect && optionalDeviceParams) {
        baseMessage = baseMessage.replace("{assetType}", optionalDeviceParams.assetType).replace("{assetName}", optionalDeviceParams.assetName).replace("{assetId}", optionalDeviceParams.assetId);
    }

    return baseMessage;
}

export function auditSkip (api, auditType: AuditType, workflow: IWorkflowKey, optionalParams?: IAuditDeviceParams) {
    let message = getAuditMessage(auditType, workflow, optionalParams);
    api.call("Add", {
        typeName: "Audit",
        entity: {
            name: auditType,
            comment: message
        }
    });
}